import React from "react";
import { Card } from "./ui/card";
import {
  Search,
  Bot,
  Video,
  TrendingUp,
  Target,
  Lightbulb,
  Zap,
  BarChart3,
  Globe
} from "lucide-react";

const Services = () => {
  const services = [
    {
      icon: Search,
      title: "Local & National SEO",
      description: "Comprehensive SEO strategies tailored to your market, driving qualified traffic and improving search rankings across all platforms."
    },
    {
      icon: Bot,
      title: "AI-Powered Marketing",
      description: "Leverage cutting-edge AI tools to create high-impact content, automate workflows, and accelerate your marketing results."
    },
    {
      icon: Video,
      title: "Video Marketing Strategy",
      description: "Short-form and long-form video content strategies for YouTube and social media that capture attention and drive engagement."
    },
    {
      icon: TrendingUp,
      title: "Website Optimization",
      description: "Technical SEO audits and conversion rate optimization to transform your website into a lead-generating machine."
    },
    {
      icon: Target,
      title: "Lead Generation",
      description: "Strategic content planning and funnel optimization that attracts, nurtures, and converts your ideal customers."
    },
    {
      icon: BarChart3,
      title: "Competitive Research",
      description: "In-depth keyword strategy and competitor analysis to identify opportunities and dominate your market niche."
    },
    {
      icon: Globe,
      title: "GEO Optimization",
      description: "Specialized geographic targeting to ensure your business appears in the right local and regional searches."
    },
    {
      icon: Zap,
      title: "Fast AI Execution",
      description: "Rapid deployment of AI-powered digital assets that deliver results quickly without compromising quality."
    },
    {
      icon: Lightbulb,
      title: "Content Strategy",
      description: "Data-driven content planning that aligns with search intent and user behavior to maximize organic reach."
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-24 px-4 sm:px-6 bg-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Services & Expertise
          </h2>
          <p className="text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto px-4">
            Specialized solutions to elevate your digital presence and drive measurable growth
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="p-8 border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 bg-white group cursor-pointer"
              >
                <div className="w-14 h-14 bg-emerald-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-emerald-600 group-hover:scale-110 transition-all duration-300">
                  <Icon className="w-7 h-7 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {service.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;